module.exports = __webpack_public_path__ + "img/bg-purple.cb06198c.png";